import { Link } from 'react-router-dom';
import { categories } from '@/mocks/siteData';

export default function CategorySection() {
  return (
    <section className="w-full px-4 md:px-6 py-14 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            全品类<strong>中文字幕日韩</strong>资源
          </h2>
          <p className="text-sm text-foreground-600 max-w-xl mx-auto">
            覆盖日韩电影、电视剧、综艺、动漫、纪录片五大品类，精准中文字幕让观影零障碍
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center p-6 rounded-xl bg-background-100 hover:bg-primary-50 border border-background-200/70 hover:border-primary-200 transition-all cursor-pointer"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-2xl bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-white transition-all mb-4">
                <i className={`${cat.icon} text-2xl`}></i>
              </div>
              <span className="font-heading font-semibold text-sm text-foreground-800 group-hover:text-primary-700 whitespace-nowrap transition-colors">
                {cat.name}
              </span>
              <span className="text-xs text-foreground-500 mt-1.5 text-center leading-relaxed">
                {cat.description}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}